import { call, put, select, takeLatest } from "redux-saga/effects";
import { fetchAuditLogActionsListApi, fetchAuditLogExportApi, fetchAuditLogListApi } from "src/services/auditLog";
import jwtManager from "src/utils/jwtManager";
import {
  changeAuditLogCount,
  fetchAuditLogActionsRequest,
  fetchAuditLogActionsSuccess,
  fetchAuditLogListFailure,
  fetchAuditLogListRequest,
  fetchAuditLogListSuccess,
  exportAuditLogRequest,
  exportAuditLogFailure,
  exportAuditLogSuccess
} from "../actions/auditLog";

function* fetchAuditLogListSaga(action: any): Generator<any, any, any> {
  try {
    const { defaultHeaders } = yield select((state) => state);
    const headers = { ...defaultHeaders, token: jwtManager.getToken() };
    const params = action.payload;
    const response = yield call(fetchAuditLogListApi, params, headers);
    const {
      data: {
        result: { message, status, data, count },
      },
    } = response;

    if (status === "Success") {
      yield put(fetchAuditLogListSuccess({ data: data }));
      yield put(changeAuditLogCount(count));
    } else {
      yield put(fetchAuditLogListFailure(message));
    }
  } catch (error) {
    yield put(fetchAuditLogListFailure(error));
  }
}

function* fetchAuditLogActionsListSaga(action: any): Generator<any, any, any> {
  try {
    const { defaultHeaders } = yield select((state) => state)
    const headers = { ...defaultHeaders, token: jwtManager.getToken() }
    const params = action.payload;
    const response = yield call(fetchAuditLogActionsListApi, params, headers);
    const {
      data: {
        result: { message, status, data },
      },
    } = response

    if (status === "Success") {
      yield put(fetchAuditLogActionsSuccess({ data }));
    } else {
      yield put(fetchAuditLogActionsSuccess(message));
    }
  } catch (error) {
    yield put(fetchAuditLogActionsSuccess(error));
  }
}

function* exportAuditLogSaga(action: any): Generator<any, any, any> {
  try {
    const { defaultHeaders } = yield select((state) => state)
    const headers = { ...defaultHeaders, token: jwtManager.getToken() }
    const params = action.payload

    const { status, data, headers: resHeaders } = yield call(
      fetchAuditLogExportApi,
      params,
      headers,
      { responseType: 'blob' }
    )

    let fileName = 'audit-log'
    const disposition = resHeaders['content-disposition']
    if (disposition) {
      const match = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)
      if (match && match[1]) fileName = match[1].replace(/['"]/g, '')
    }

    const blob = new Blob([data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    })
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', fileName)
    document.body.appendChild(link)
    link.click()
    link.remove()

    if (status === 200) {
      yield put(exportAuditLogSuccess())
    } else {
      yield put(exportAuditLogFailure())
    }
  } catch (error) {
    yield put(exportAuditLogFailure(error))
  }
}

export default function* rootSaga(): Generator<any, any, any> {
  yield takeLatest(fetchAuditLogListRequest, fetchAuditLogListSaga);
  yield takeLatest(fetchAuditLogActionsRequest, fetchAuditLogActionsListSaga);
  yield takeLatest(exportAuditLogRequest, exportAuditLogSaga);
}